import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ColumnState } from 'ag-grid-community-new';

import { TableIds } from 'types/_common';

import { getActualColumnStateFields } from 'utils/table';

import { revertAllAvailableSlicesForMassRevert } from '../redux';

type TableState = {
  defaultLocalTableSettings: {
    [key: string]: ColumnState[] | undefined;
  };
};

const initialState: TableState = {
  defaultLocalTableSettings: {},
};

export const tableSlice = createSlice({
  name: 'tableSlice',
  initialState,
  extraReducers: (builder) => builder.addCase(revertAllAvailableSlicesForMassRevert, () => initialState),
  reducers: {
    setDefaultLocalTableSettings(
      state,
      action: PayloadAction<{
        tableId: TableIds;
        defaultSettings: ColumnState[];
      }>,
    ) {
      state.defaultLocalTableSettings[action.payload.tableId] = getActualColumnStateFields(action.payload.defaultSettings);
    },
  },
});

export default tableSlice.reducer;
